module.exports = __webpack_public_path__ + "img/bioManta1.27f065f3.png";